<template>
  <div>
    <part-master v-if="id === 'parts'" />
    <!-- <asset-config v-else-if="id === 'assets'" /> -->
    <import-plans v-else-if="id === 'import' && isPlanImportEnabled" />
  </div>
</template>

<script>
import PartMaster from './PartMaster.vue';
// import AssetConfig from './AssetConfig.vue';
import ImportPlans from './ImportPlans.vue';
import planningConfigMixin from '../../mixins/planning-config';

export default {
  name: 'AdminWindow',
  mixins: [planningConfigMixin],
  components: {
    PartMaster,
    // AssetConfig,
    ImportPlans,
  },
  computed: {
    id() {
      return this.$route.params.id;
    },
  },
};
</script>
